<!--
  @Description: 
  @Author: wang.y 
  @Date: 2024-07-25 
-->
<template>
  <div class="entity-item">
    <img :src="itemDetail.logoPath | logo_show" />
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  props: {
    itemDetail: {
      default: () => {},
    },
  },
  components: {},
  created() {},
  mounted() {},
  data() {
    return {}
  },
  computed: {
    ...mapState({
      index2_path: (state) => state.index2_path,
      isMobile: (state) => state.isMobile,
      language: (state) => state.language,
    }),
  },
  methods: {
    toEntity() {
      if (!this.itemDetail.entityUid) {
        // this.showError(this.language == 'zh' ? '该企业暂无详情' : 'This company has no details yet')
        return
      }
      const entityTypeMap = {
        0: 'companyDetail',
        1: 'orgDetail',
        3: 'hospitalDetail',
        4: 'parkDetail',
      }

      const entityType = this.itemDetail.entityType
      const path = entityTypeMap[entityType]

      if (!path) {
        // this.showError(this.language == 'zh' ? '未知的实体类型' : 'Unknown entity type')
        return
      }

      const href = `${this.index2_path}/${path}/${this.itemDetail.entityUid}`
      
      if (this.isMobile) {
        window.location.href = href
      } else {
        window.open(href, '_blank')
      }
    },
    showError(message) {
      if (this.isMobile) {
        this.$notify(message)
      } else {
        this.$Message.error(message)
      }
    },
  },
}
</script>
<style lang='stylus' scoped>
.entity-item
  height 50px
  background #FFFFFF
  box-shadow 0px 3px 8px 0px rgba(0, 0, 0, 0.16)
  display flex
  align-items center
  justify-content center
  // cursor pointer
  img
    max-width 100%
    max-height 100%
</style>